import '@/app/app.css';
import './main.css';
import '@/app/app';

/* Promo slider */
import { mainPromoSlider } from '@/features/main/main-hero/main-promo-slider/main-promo-slider';
window.addEventListener('DOMContentLoaded', () => {
	mainPromoSlider();
});

/* Featured slider */
import { mainFeaturedSlider } from '@/features/main/main-featured/main-featured';
window.addEventListener('DOMContentLoaded', () => {
	mainFeaturedSlider();
});

/* Service slider */
import { mainServiceSlider } from '@/features/main/main-service/main-service';
window.addEventListener('DOMContentLoaded', () => {
	mainServiceSlider();
});

/* Testimonials collapse */
import { mainTestimonialsCollapse } from '@/features/main/main-testimonials/main-testimonials';
window.addEventListener('DOMContentLoaded', () => {
	mainTestimonialsCollapse();
});

/* Marquee */
import { marquee } from '@/shared/common/marquee/marquee';
window.addEventListener('DOMContentLoaded', () => {
	marquee();
});

/* Notice */
import { notice } from '@/shared/notice/notice';
window.addEventListener('DOMContentLoaded', () => {
	notice();
});
